import { defineStore } from "pinia";
import { i18n } from "@/boot/i18n";
import { TLangCode } from "@/modules/language/types";

const i18nLocal = i18n;
i18nLocal.global.locale.value =
  (localStorage.getItem("selected-language") as TLangCode) || "ru";

export const translateStore = defineStore("translate-store", {
  state: () => ({
    t: i18nLocal.global.t,
  }),
});
